import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=e8bef518&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=e8bef518&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bef518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8bef518')) {
      api.createRecord('e8bef518', component.options)
    } else {
      api.reload('e8bef518', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=e8bef518&scoped=true", function () {
      api.rerender('e8bef518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/series-documentales/Form.vue"
export default component.exports